import { arabicChar, arabicMonths } from "./archaracter";
require("hijri-date");

export class HigriConvert {
  convert(date) {
    let dateObj = new Date(date);
    let newDate = "";

    let formattedDate = dateObj.toLocaleString("ar-SA", {
      year: "numeric",
      month: "numeric",
      day: "2-digit",
    });
    let format = formattedDate.split("/");
    let year = format[2].split(" ");

    let newdateformat = {
      day: format[0].trim(),
      month: format[1].trim(),
      year: year[0].trim(),
    };

    for (let r = 0; r < newdateformat.year.length; r++) {
      let letter = arabicChar.find((res) =>
        res.arVal.match(newdateformat.year[r])
      );
      if (letter) {
        newDate += letter.enVal;
      }
    }
    newDate += "-";
    let monthDATE = "";
    for (let r = 0; r < newdateformat.month.length; r++) {
      let letter = arabicChar.find((res) =>
        res.arVal.match(newdateformat.month[r])
      );
      if (letter) {
        monthDATE += letter.enVal;
      }
    }
    if (monthDATE.length == 1) {
      monthDATE = "0" + monthDATE;
    }
    newDate += monthDATE;
    newDate += "-";

    // if (newdateformat.day.length == 1) {
    //   let letter = arabicChar.find((res) => res.arVal.match(newdateformat.day));
    //   newDate += "0" + letter.enVal;
    // } else {
    //   for (let r = 0; r < newdateformat.day.length; r++) {
    //     let letter = arabicChar.find((res) =>
    //       res.arVal.match(newdateformat.day[r])
    //     );
    //     if (letter) {
    //       newDate += letter.enVal;
    //     }
    //   }
    // }

    return newDate;
  }
  getHigriArabic(date) {
    if (date) {
      let format = date.split("T")[0];
      let newDate = format.split("/");
      let newDateFomat = "";
      let newdateformat = {
        day: newDate[2],
        month: newDate[1],
        year: newDate[0],
      };
      newDateFomat += newdateformat.day;
      newDateFomat += " ";
      newDateFomat += arabicMonths.filter((res) => {
        return res.number == newdateformat.month;
      })[0].name;

      newDateFomat += " ";
      for (let i = 0; i < newdateformat.year.length; i++) {
        let letter = arabicChar.find((res) =>
          res.enVal.match(newdateformat.year[i])
        );
        if (letter) newDateFomat += letter.arVal;
      }

      newDateFomat += "هـ";

      return newDateFomat;
    }
  }
  getFullHigriArabicWithTime(date) {
    if (date) {
      let format = date.split("T")[0];
      let newDate = format.split("-");
      let newDateFomat = "";
      let newdateformat = {
        day: newDate[2],
        month: newDate[1],
        year: newDate[0],
      };

      let timeFormat = date.split("T")[1];
      let newTime = timeFormat.split(":");
      let ampm = newTime[0] >= 12 ? "م" : "ص";
      let hours = newTime[0] % 12;
      hours = hours ? hours : 12;
      hours = hours.toString();
      let minutes = newTime[1];
      minutes = minutes.toString();
      timeFormat =
        this.getArabicLetter(hours) +
        ":" +
        this.getArabicLetter(minutes) +
        " " +
        ampm;

      for (let i = 0; i < newdateformat.day.length; i++) {
        if (i == 0) {
          if (newdateformat.day[i] == arabicChar[i].enVal) continue;
        }

        let letter = arabicChar.find((res) =>
          res.enVal.match(newdateformat.day[i])
        );
        if (letter) newDateFomat += letter.arVal;
      }
      newDateFomat += " ";

      newDateFomat += arabicMonths.find(
        (res) => res.number == newdateformat.month
      ).name;

      newDateFomat += " ";
      for (let i = 0; i < newdateformat.year.length; i++) {
        let letter = arabicChar.find((res) =>
          res.enVal.match(newdateformat.year[i])
        );
        if (letter) newDateFomat += letter.arVal;
      }

      newDateFomat += "هـ";

      return newDateFomat + " " + timeFormat;
    }
  }
  getFullHigriArabicWithoutTime(date) {
    if (date) {
      let format = date.split("T")[0];
      let newDate = format.split("-");
      let newDateFomat = "";
      let newdateformat = {
        day: newDate[2],
        month: newDate[1],
        year: newDate[0],
      };
      for (let i = 0; i < newdateformat.day.length; i++) {
        if (i == 0) {
          if (newdateformat.day[i] == arabicChar[i].enVal) continue;
        }

        let letter = arabicChar.find((res) =>
          res.enVal.match(newdateformat.day[i])
        );
        if (letter) newDateFomat += letter.arVal;
      }
      newDateFomat += " ";

      newDateFomat += arabicMonths.find(
        (res) => res.number == newdateformat.month
      ).name;

      newDateFomat += " ";
      for (let i = 0; i < newdateformat.year.length; i++) {
        let letter = arabicChar.find((res) =>
          res.enVal.match(newdateformat.year[i])
        );
        if (letter) newDateFomat += letter.arVal;
      }

      newDateFomat += "هـ";

      return newDateFomat;
    }
  }

  getArabicLetter(value) {
    let newFormat = "";
    for (let i = 0; i < value.length; i++) {
      let letter = arabicChar.find((res) => res.enVal.match(value[i]));
      if (letter) newFormat += letter.arVal;
    }

    return newFormat;
  }

  getGregoni(date) {
    if (date) {
      let format = date.split("T")[0];
      let newDate = format.split("-");
      let newdateformat = {
        day: newDate[2],
        month: newDate[1],
        year: newDate[0],
      };

      let GregorianDate = new HijriDate(
        Number(newdateformat.year),
        Number(newdateformat.month),
        Number(newdateformat.day)
      ).toGregorian();

      let ndate = GregorianDate.toLocaleString("en-SA", {
        year: "numeric",
        month: "numeric",
        day: "2-digit",
      }).split("/");

      return ndate[2] + "-" + ndate[0] + "-" + ndate[1];
    }
  }
}
